import React, { useEffect, useState } from "react";
import {auth} from './FirebaseConfig';

export const AuthContext = React.createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((authUser) => {
        if (authUser){
            //user has logged in
            console.log(authUser);
            setUser(authUser);
        }
        else{
            //user has logged out
            setUser(null);
        }
    });
    return () => {
        unsubscribe(); //cleanup
    }
}, [user]);

  return (
    <AuthContext.Provider value={{ user }}>{children}</AuthContext.Provider>
  );
};